import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '@/layouts/AppLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { authRoutes } from '@/features/auth/routes';
import { guideLifecycleRoutes } from '@/features/guide-profile/routes';
import { publicRoutes } from '@/features/home/routes';
import { guideRouteTree } from '@/features/guide/routes';
import { adminRouteTree } from '@/features/admin/routes';
import { BecomeGuidePage } from '@/features/guide-profile/pages/BecomeGuidePage';

export const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: authRoutes,
  },
  // `/become-guide` is public and sits OUTSIDE AppLayout: inside it, the
  // traveler RoleSurfaceGate redirected visitors before the page could mount.
  { path: '/become-guide', element: <BecomeGuidePage /> },
  guideLifecycleRoutes,
  adminRouteTree,
  guideRouteTree,
  {
    path: '/',
    element: <AppLayout />,
    children: [...publicRoutes, { path: '*', element: <Navigate to="/" replace /> }],
  },
]);
